export const OPERATION_NAME_LIMITS = {
  min: 1,
  max: 64,
} as const;

export const OPERATION_DESCRIPTION_LIMITS = {
  max: 1000,
} as const;

export const TAG_NAME_LIMITS = {
  min: 1,
  max: 64,
} as const;

export const SEARCH_LIMITS = {
  min: 2,
  max: 100,
} as const;
